
import { computed, defineComponent, PropType } from 'vue'

import useValidationMessages from '@/common/composable/useValidationMessages'
import { ErrorObject } from '@vuelidate/core'

export default defineComponent({
    props: {
        name: {
            type: String,
            default: null,
        },
        value: {
            type: Array as PropType<File[]>,
            default: () => [],
        },
        placeholder: {
            type: String,
            default: null,
        },
        accept: {
            type: String,
            default: 'image/*',
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        loading: {
            type: Boolean,
            default: false,
        },
        multiple: {
            type: Boolean,
            default: false,
        },
        isInvalid: {
            type: Boolean,
            default: false,
        },
        validationErrors: {
            type: Array as PropType<ErrorObject[]>,
            default: () => [],
        },
    },
    emits: ['update:value', 'change'],
    setup(props, { emit }) {
        const { getValidationMessage } = useValidationMessages()

        const computedPlaceholder = computed(() => {
            if (props.value.length) {
                if (props.value.length > 1) {
                    return `Прикреплено: ${props.value.length}`
                }

                return props.value[0].name
            }

            return 'Выбрать файл'
        })

        const emitUpdate = (event: InputEvent) => {
            const target = event.target as HTMLInputElement
            const files = target.files

            const array_of_files: File[] = []

            if (!files || !files.length) {
                emit('update:value', array_of_files)
                emit('change', array_of_files)
                return
            }

            for (let index = 0; index < files.length; index++) {
                const file = files.item(index)
                if (!file) continue
                array_of_files.push(file)
            }

            if (props.multiple) {
                const value_files = [...props.value]
                emit('update:value', value_files.concat(array_of_files))
                emit('change', value_files.concat(array_of_files))
            } else {
                emit('update:value', array_of_files)
                emit('change', array_of_files)
            }

            target.value = ''
        }

        const resetFiles = () => {
            emit('update:value', [])
            emit('change', [])
        }

        const removeFile = (file_index: number) => {
            const files = [...props.value]
            files.splice(file_index, 1)

            emit('update:value', files)
            emit('change', files)
        }

        return { computedPlaceholder, emitUpdate, getValidationMessage, resetFiles, removeFile }
    },
})
